import React, { Component } from "react";
import { Row, Col, FormInput, FormCheckbox } from "shards-react";
import { Form } from "react-bootstrap";

export default class userRoleFrom extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async componentDidMount() {
    await this.setState(this.props.values);
  }

  handleChange(e, name) {
    const newState = {};
    newState[name] = !this.state[name];
    this.setState({ ...this.state, ...newState });
    this.props.values[name] = !this.props.values[name];
  }

  render() {
    const { values, handleChange, isDisableField, handleBlur } = this.props;

    return (
      <React.Fragment>
        <fieldset disabled={isDisableField}>
          <Row form>
            <Col md="12" className="form-group">
              <label>Role Name</label>
              <FormInput
                name="role_name"
                id="role_name"
                onChange={handleChange}
                value={values.role_name}
              />
            </Col>
          </Row>

          <Row form className="mt-3">
            <Col md="12" className="form-group">
              <label class="h6">จัดการการประชุม</label>
              <hr className="mt-2" />

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Add/Edit/Delete Meeting
                      </label>
                      <p className="font-11 text-muted mb-0">
                        เพิ่ม,แก้ไข,ลบ การประชุม
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_meeting}
                      onChange={e => this.handleChange(e, "manage_meeting")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Manage Participants
                      </label>
                      <p className="font-11 text-muted mb-0">
                        จัดการผู้เข้าร่วมประชุม
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_participants}
                      onChange={e => this.handleChange(e, "manage_participants")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Meeting Documents
                      </label>
                      <p className="font-11 text-muted mb-0">
                        จัดการเอกสารการประชุม
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_document}
                      onChange={e => this.handleChange(e, "manage_document")}
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Attachment
                      </label>
                      <p className="font-11 text-muted mb-0">จัดการเอกสารแนบ</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_attach_file}
                      onChange={e => this.handleChange(e, "manage_attach_file")}
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row form className="mt-3">
            <Col md="12" className="form-group">
              <label class="h6">ข้อมูลอ้างอิง</label>
              <hr className="mt-2" />

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Meeting Location
                      </label>
                      <p className="font-11 text-muted mb-0">สถานที่ประชุม</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_location}
                      onChange={e => this.handleChange(e, "manage_location")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Building
                      </label>
                      <p className="font-11 text-muted mb-0">อาคาร</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_building}
                      onChange={e => this.handleChange(e, "manage_building")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Room
                      </label>
                      <p className="font-11 text-muted mb-0">ห้องประชุม</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_room}
                      onChange={e => this.handleChange(e, "manage_room")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Title
                      </label>
                      <p className="font-11 text-muted mb-0">คำนำหน้าชื่อ</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_title}
                      onChange={e => this.handleChange(e, "manage_title")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        Position
                      </label>
                      <p className="font-11 text-muted mb-0">ตำแหน่ง</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_position}
                      onChange={e => this.handleChange(e, "manage_position")}
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row form className="mt-3">
            <Col md="12" className="form-group">
              <label class="h6">ผู้ดูแลระบบ</label>
              <hr className="mt-2" />

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        User
                      </label>
                      <p className="font-11 text-muted mb-0">
                        จัดการข้อมูลผู้ใช้งาน
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_user}
                      onChange={e => this.handleChange(e, "manage_user")}
                    ></FormCheckbox>
                  </div>
                </Col>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        User Role
                      </label>
                      <p className="font-11 text-muted mb-0">กำหนด User Role</p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.manage_role}
                      onChange={e => this.handleChange(e, "manage_role")}
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row form className="mt-3">
            <Col md="12" className="form-group">
              <label class="h6">สำนักต่างๆ</label>
              <hr className="mt-2" />

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักสนับสนุนงานวิจัย
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Research Promotion
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.research_promotion}
                      onChange={e => this.handleChange(e, "research_promotion")}
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักส่งเสริมการใช้ประโยชน์
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Research Utilization
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.research_utilization}
                      onChange={e =>
                        this.handleChange(e, "research_utilization")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักพัฒนาบุคลากรวิจัย
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Research Capabilities Enhancement
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.research_capability}
                      onChange={e =>
                        this.handleChange(e, "research_capability")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักเทคโนโลยีสารสนเทศ
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Information Technology
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.information_technology}
                      onChange={e => this.handleChange(e, "information_technology")}
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักบริหาร
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of General Administration
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.general_admin}
                      onChange={e =>
                        this.handleChange(e, "general_admin")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักนโยบายและแผน
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Policy and Plan
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.policy_plan}
                      onChange={e =>
                        this.handleChange(e, "policy_plan")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>

              <Row form>
                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักผู้อำนวนการและสื่อสารองค์กร
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Executive Director and Communication
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.executive_director}
                      onChange={e => this.handleChange(e, "executive_director")}
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        สำนักกฏหมาย
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Office of Law
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.law}
                      onChange={e =>
                        this.handleChange(e, "law")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>

                <Col md="4" className="form-group">
                  <div className="d-flex align-items-center">
                    <div class="flex-fill">
                      <label
                        className="mb-0"
                        style={{ position: "relative", top: "-1px" }}
                      >
                        หน่วยตรวจสอบภายใน
                      </label>
                      <p className="font-11 text-muted mb-0">
                        Internal Audit Group
                      </p>
                    </div>
                    <FormCheckbox
                      toggle
                      checked={this.state.internal_audit}
                      onChange={e =>
                        this.handleChange(e, "internal_audit")
                      }
                    ></FormCheckbox>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </fieldset>
      </React.Fragment>
    );
  }
}
